import { Button } from "react-bootstrap";
import { useNavigate } from "react-router";

function HostedFullRedirectButton()
{
    const navigate = useNavigate();

    function handleClick() {
      navigate("/checkout-redirect");
    }

    return  <Button variant="primary" onClick={handleClick}>Launch Hosted Checkout (Full Redirect)</Button>

}

export default HostedFullRedirectButton;